export default __webpack_public_path__ + "media/portrait/logo_audi-e7e8b19e.svg";